import error from './error.ar'
import links from './links.ar'
import words from './words.ar'
import header from './header.ar'
import validations from './validations.ar'

export default {
  error,
  links,
  words,
  header,
  validations,
} as const
